import urljoin from 'url-join';
import StoreType from '@/typings/storeType';

(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('StoreCtrl', storeCtrl);

    function storeCtrl($scope, $rootScope, $sce, $location, AuthService, $timeout) {
        $scope.iFrameLoading = true;
        const extraPath = ['/affiliates', '/earnings'].includes($location.path())
            ? $location.path()
            : $location.path().split('/store')[1];
        const storeIframeQueryChangedAction = 'store-route-query-changed';
        const orderListQueryKeys = [
            'search',
            'page',
            'size',
            'sortBy',
            'sortDir',
            'datePreset',
            'dateFrom',
            'dateTo',
            'orderType'
        ];
        const shopifyAppOrigin = new URL(process.env.VUE_APP_SHOPIFY_APP_URL).origin;
        const buildQueryParams = (query) =>
            Object.keys(query)
                .filter((key) => query[key] !== undefined && query[key] !== null && query[key] !== '')
                .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
                .join('&');
        const appendQueryParam = (query, key, value) => {
            const param = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            return query?.length ? `${query}&${param}` : param;
        };
        const normalizeStorePath = (path) => `/${String(path || '').replace(/^\/+|\/+$/g, '')}`;
        const isCurrentIframePath = (path) => normalizeStorePath(path) === normalizeStorePath(extraPath);
        const isOrderListQueryKey = (key) => orderListQueryKeys.includes(key);
        const getOrderListQueryKeys = (queryKeys) =>
            (Array.isArray(queryKeys) ? queryKeys : orderListQueryKeys).filter(isOrderListQueryKey);
        const hasOrderListQueryParams = (searchParams) =>
            orderListQueryKeys.some((key) => Object.prototype.hasOwnProperty.call(searchParams, key));
        const isOrdersPath = () => normalizeStorePath($location.path().split('/store')[1]) === '/orders';
        const areSearchParamsEqual = (left, right) => {
            const leftKeys = Object.keys(left).sort();
            const rightKeys = Object.keys(right).sort();
            if (leftKeys.length !== rightKeys.length) return false;

            return leftKeys.every((key, index) => key === rightKeys[index] && String(left[key]) === String(right[key]));
        };
        const syncStoreRouteQuery = (event) => {
            const data = event.data;
            if (event.origin !== shopifyAppOrigin || data?.action !== storeIframeQueryChangedAction) return;
            if (!isCurrentIframePath(data.path)) return;

            const nextSearch = { ...$location.search() };
            const queryKeys = getOrderListQueryKeys(data.queryKeys);
            queryKeys.forEach((key) => delete nextSearch[key]);

            Object.keys(data.query || {}).forEach((key) => {
                if (!isOrderListQueryKey(key)) return;
                const value = data.query[key];
                if (value === undefined || value === null || value === '') return;
                nextSearch[key] = String(value);
            });

            if (areSearchParamsEqual($location.search(), nextSearch)) return;

            $scope.$evalAsync(() => {
                $location.search(nextSearch);
                $location.replace();
            });
        };
        let queryParams = buildQueryParams($location.search());

        window.addEventListener('message', syncStoreRouteQuery);
        $scope.$on('$destroy', () => window.removeEventListener('message', syncStoreRouteQuery));

        // Do we have an active session?
        $scope.$on('route:success', (_, user) => {
            const accessRoles = user.AccessRoles.Serialized.split(',') || [];
            if (
                user &&
                (user.Stores?.filter(
                    (s) =>
                        s.Type === StoreType.Shopify ||
                        s.Type === StoreType.WooCommerce ||
                        s.Type === StoreType.Etsy ||
                        s.Type === StoreType.TikTok ||
                        s.Type === StoreType.Shoplazza ||
                        s.Type === StoreType.Amazon
                ).length ||
                    accessRoles.includes('affiliate') ||
                    accessRoles.includes('custom-store'))
            ) {
                if ($rootScope.shProduct) {
                    queryParams = buildQueryParams({
                        product: $rootScope.shProduct.id,
                        template: $rootScope.shProduct.templateId,
                        templateName: $rootScope.shProduct.templateName,
                        createSetFromTemplate: $rootScope.shProduct.createSetFromTemplate
                    });
                    $rootScope.shProduct = null;
                }

                const isWooUser = $rootScope.user.Stores[0] && $rootScope.user.Stores[0].Type == StoreType.WooCommerce;
                if (isWooUser) {
                    queryParams = appendQueryParam(queryParams, 'isWooUser', 'true');
                }

                if ($rootScope.isCollectiveRetailUser) {
                    queryParams = appendQueryParam(queryParams, 'collectiveRetail', 'true');
                }
                const iFrameUrl = urljoin(
                    process.env.VUE_APP_SHOPIFY_APP_URL,
                    extraPath,
                    queryParams ? '?' + queryParams : ''
                );

                // Get an object generated from the URL which is needed to load the iFrame src dynamically
                $scope.iFrameUrl = $sce.trustAsResourceUrl(iFrameUrl);
                $timeout(() => {
                    $scope.$apply();
                    const locationSearch = $location.search();
                    if (locationSearch.lastCreatedTemplateId) {
                        delete locationSearch.lastCreatedTemplateId;
                        $location.search(locationSearch); // Move to the router with parameters without lastCreatedTemplateId
                    }
                });
            } else {
                // If the user shouldn't be here, return to home
                $location.path('/home');
            }
        });

        $scope.onScopesModalClose = function () {
            $rootScope.storesNeedScopes = false;
        };

        $scope.onEtsyStoreNeedsReconnectionModalClose = function () {
            $rootScope.hasEtsyStoreNeedsReconnection = false;
        };

        $scope.onTikTokStoreNeedsReconnectionModalClose = function () {
            $rootScope.hasTikTokStoreNeedsReconnection = false;
        };

        $scope.onEtsyStoreNeedsReconnectionModalNavigateToSettings = function () {
            $scope.navigate('/store/settings/');
        };

        $scope.createTemplateEvent = function () {
            window.addEventListener('message', function (event) {
                if (event.data && event.data.action === 'new-template-creation-flow') {
                    const data = event.data;
                    const templateId = data.templateId;
                    const forUserDesignCreation = data.forUserDesignCreation;
                    const createDesignOnTemplate = data.createDesignOnTemplate;
                    const flowId = data.flowId;

                    this.location.href =
                        '/createProduct1?' +
                        new URLSearchParams({
                            ...(templateId && { templateId }),
                            ...(forUserDesignCreation && { forUserDesignCreation }),
                            ...(createDesignOnTemplate && { createDesignOnTemplate }),
                            ...(flowId && { flowId })
                        });
                } else if (event.data?.action === 'customize-before-merge') {
                    $rootScope.beforeMergeProduct = event.data;
                    const step1 = '/createProduct1';

                    $location.path(step1);
                    $timeout(() => $scope.$apply());
                } else if (event.data?.action === 'customize-before-merge-create-design') {
                    $rootScope.productBuilderDesign = event.data;
                    $location.path('/createProduct1').search({
                        forDesignTemplateCreation: 'true',
                        forMyDesigns: 'true'
                    });
                    $timeout(() => $scope.$apply());
                } else if (event.data?.action === 'product-base-from-listing') {
                    $rootScope.productBaseFromListing = event.data;
                    $location.path('/createProduct3').search({
                        fromListing: 'true',
                        forProductTemplateCreation: 'true',
                        forMyProductBases: 'true'
                    });

                    $timeout(() => $scope.$apply());
                }
            });
        };

        $scope.createTemplateEvent();

        $scope.iFrameLoaded = function () {
            $scope.iFrameLoading = false;
            window.addEventListener('message', function (event) {
                if (
                    event.data?.action === 'design-library-ready' &&
                    $rootScope.beforeMergeProduct?.printAreaDimensions
                ) {
                    const { productInfo, selectedStoreUrl } = $rootScope.beforeMergeProduct;
                    event.source.postMessage(
                        {
                            productInfo,
                            selectedStoreUrl,
                            action: 'customize-before-merge-completed'
                        },
                        `${process.env.VUE_APP_SHOPIFY_APP_URL}/store/designLibrary`
                    );
                    $rootScope.beforeMergeProduct = null;
                } else if (
                    event.data?.action === 'pod-selection-ready' &&
                    $rootScope.beforeMergeProduct?.printAreaDimensions
                ) {
                    const { productModel, productBuilderInfo, selectedStoreUrl } = $rootScope.beforeMergeProduct;
                    event.source.postMessage(
                        {
                            productModel,
                            productBuilderInfo,
                            selectedStoreUrl,
                            action: 'pod-selection-customize-before-merge-completed'
                        },
                        `${process.env.VUE_APP_SHOPIFY_APP_URL}/store/podSelection`
                    );
                    $rootScope.beforeMergeProduct = null;
                } else if (
                    event.data?.action === 'pod-selection-ready' &&
                    $rootScope.productBuilderDesign?.printAreaDimensions
                ) {
                    const { productModel, productBuilderInfo, selectedStoreUrl, createdDesign, targetSector } =
                        $rootScope.productBuilderDesign;
                    event.source.postMessage(
                        {
                            productModel,
                            productBuilderInfo,
                            selectedStoreUrl,
                            createdDesign,
                            targetSector,
                            action: 'pod-selection-customize-before-merge-completed'
                        },
                        `${process.env.VUE_APP_SHOPIFY_APP_URL}/store/podSelection`
                    );
                    $rootScope.productBuilderDesign = null;
                } else if (
                    event.data?.action === 'pod-selection-ready' &&
                    $rootScope.productBaseFromListing?.productBaseId
                ) {
                    const { store, productId, productBaseId } = $rootScope.productBaseFromListing;
                    event.source.postMessage(
                        {
                            store,
                            spProductId: productId,
                            templateId: productBaseId,
                            action: 'product-base-from-listing-created'
                        },
                        `${process.env.VUE_APP_SHOPIFY_APP_URL}/store/podSelection`
                    );
                    $rootScope.productBaseFromListing = null;
                }
            });
        };

        $rootScope.$on('$routeChangeStart', function (_, nextRoute) {
            let searchParams = $location.search();

            if (searchParams.lastCreatedTemplateId || (isOrdersPath() && hasOrderListQueryParams(searchParams))) {
                nextRoute.$$route.reloadOnSearch = false;
            } else {
                nextRoute.$$route.reloadOnSearch = true;
            }
        });
    }
})();
